module.exports = __webpack_public_path__ + "static/media/sports_9.d9d1936a.jpg";